import './index.css'
import Button from '../button'

function PricingModule({price,interval,CTA,checkOutUrl}){
    const sendToSignupPage = (interval) =>{
        let locToSend = "/signup"
        window.location.href = locToSend;
    }
    return <div className='pricing-module'>
    <div className='small-text highlight-green'>{interval}</div>
    <h2 className='big-text'>{price}</h2>
    <Button text={CTA} addedFunction={sendToSignupPage} params={interval}></Button>
    <div className='benefits-grid'>
        <div className='globule'></div>
        <div className='benefit small-text'>Up to 10 sites</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Unlimited blog and social post ideas</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Content scheduler</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Download to Word</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Unlimited feed items</div>
    </div>
    </div>
}

export default PricingModule